import {isDefined} from "../../libs/utils/epic.utils";
import {Interval} from "../../libs/enum/interval";

export class OccurrenceDto {

  public id!: string;
  public date!: Date;
  public interval!: Interval;
  public label: string | undefined;

  constructor(init?: Partial<OccurrenceDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.date)) {
      this.date = new Date(init.date);
    }
  }
}
